
import CommandsDesktop from './commands-desktop.vue'
import {groupSkills} from './commands-menu-defs'
import {normalizeSkills} from '../chat-input-defs.js'

export default {
  components: {CommandsDesktop},
  props: {
    skills: {type: Array, default: () => []},
  },
  emits: ['skill'],
  computed: {
    shortcut_groups() {
      return groupSkills(this.normalized_skills)
    },
    normalized_skills() {
      return normalizeSkills(this.skills)
    }
  }
}
